import React, { createContext, useState } from 'react';
import axios from 'axios';
import config from '../config/config'

export const BlogContext = createContext();

export function BlogProvider(props) {

  const [blogs, setBlogs] = useState([])
  const [publishedBlogs, setPublishedBlogs] = useState([])
  const [blogsSearch, setBlogsSearch] = useState([])
  const [blogCount, setBlogCount] = useState(0)
  const [page, setPage] = useState(1)

  const getBlogs = async (page) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/blog/paginated/${page}/15`);
      setBlogs(response.data);

    } catch (err) {
      console.log(err);
    }
  }

  const getPublishedBlogs = async (page) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/blog/published`);
      setPublishedBlogs(response.data);

    } catch (err) {
      console.log(err);
    }
  }

  const getBlogCount = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/blog/count`);
      setBlogCount(response.data);

    } catch (err) {
      console.log(err);
    }
  }

  const searchBlog = async (string) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/blog/search/${string}`);
      setBlogsSearch(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  const createBlog = async (data) => {
    try {
      await axios.post(`${config.apiUrl}/api/blog/create`, { ...data });
      await Promise.all([getBlogs(page), getBlogCount()])
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const editBlog = async (id, data) => {
    try {
      await axios.put(`${config.apiUrl}/api/blog/edit-cms/${id}`, data);
      await Promise.all([getBlogs(page), getBlogCount()])
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const publishBlog = async (id, bool) => {
    try {
      await axios.put(`${config.apiUrl}/api/blog/change-publish/${id}`, { publish: bool });
      getBlogs(page)
    } catch (err) {
      console.log(err);
    }
  }

  const deleteBlog = async (id) => {
    try {
      await axios.put(`${config.apiUrl}/api/blog/delete/${id}`);
      getBlogs(page)
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <BlogContext.Provider
      value={{
        getBlogs,
        blogs,
        getPublishedBlogs,
        publishedBlogs,
        getBlogCount,
        blogCount,
        searchBlog,
        blogsSearch,
        createBlog,
        editBlog,
        publishBlog,
        page,
        setPage,
        deleteBlog
      }}
    >
      {props.children}
    </BlogContext.Provider>
  );
}
